import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		marginLeft: '2rem',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center',
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(20)
	},
	subHeading: {
		marginLeft: '2rem',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center',
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(16)
	},
	buttonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		margin: '2rem',
		columnGap: '1rem'
	},
	
	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 'fit-content !important',
		height: 'fit-content',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '1rem',
		overflowY: 'scroll'
	},

	modalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	tableWrapper: {},

}));
